module.exports = __webpack_public_path__ + "media/public/images/about/services/06-db9e025783b19c78aae524ee2c972220.jpg";